module.exports = __webpack_public_path__ + "img/12.35398835.svg";